exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.category-button[data-v-4f9b67e6] {\n  cursor: pointer;\n  color: #0966c3;\n}\n", ""]);

// exports
